import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { createFileRoute } from "@tanstack/react-router";
import { Hand, Navigation, ReceiptText, Search } from "lucide-react";
import { SupportStepRow } from "~/components/SupportStepRow";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/support/how-to-use/instant-buy")({
	beforeLoad: () => {
		document.title = "bacehub | Chat & Support";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const steps = [
		{
			icon: Search,
			title: i18n.BROWSE_OUR_PRODUCTS(),
			description: i18n.BROWSE_PRODUCTS_DESC(),
		},
		{
			icon: Navigation,
			title: i18n.GO_TO_HUB(),
			description: i18n.GO_TO_HUB_DESC(),
		},
		{
			icon: ReceiptText,
			title: i18n.COMPLETE_ORDER_INSTANT(),
			description: i18n.COMPLETE_ORDER_INSTANT_DESC(),
		},
		{
			icon: Hand,
			title: i18n.PICK_UP_ORDER(),
			description: i18n.PICK_UP_ORDER_DESC(),
		},
	];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="px-6 py-2 text-2xl font-breit">
				<T>{i18n.HOW_INSTANT_BUY_WORKS()}</T>
			</h1>
			<div className="mx-6">
				{steps.map((step) => (
					<SupportStepRow key={step.title} {...step} />
				))}
			</div>
		</PageContainer>
	);
}
